module.exports = __webpack_public_path__ + "img/golmidia.ec307bc6.png";